import * as React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { centered_flex_box } from "../../app/components/Styles";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { getPolicy } from "../../app/store/actions/commonActions";
import { MarketingPage, MarketingCard, MarketingButton } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionLabelSx,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const Policy = ({ getPolicy, policy, isLoading }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    getPolicy();
  }, []);

  if (isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ ...centered_flex_box, py: 8 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
        </Box>
      </MarketingPage>
    );
  }

  return (
    <MarketingPage maxWidth="md">
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography sx={sectionLabelSx}>Legal</Typography>
        <Typography variant="h2" sx={{ ...sectionTitleSx, fontSize: { xs: "1.75rem", md: "2.25rem" } }}>
          Privacy Policy
        </Typography>
      </Box>
      <MarketingCard>
        <Box sx={{ "& p, & li": { fontFamily: marketingFonts.body, color: marketingColors.gray600, lineHeight: 1.7 } }}>
          <ReactMarkdown>{policy}</ReactMarkdown>
        </Box>
        <Box sx={{ mt: 3 }}>
          <MarketingButton onClick={() => navigate("/contact")}>Contact Us</MarketingButton>
        </Box>
      </MarketingCard>
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  policy: state?.records?.results,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { getPolicy };

export default connect(mapStateToProps, mapDispatchToProps)(Policy);
